var map = {
    selector: '[data-map]',
    init: function() {
        var self = this;

        if ( typeof mapboxData !== "undefined" && mapboxData.hasOwnProperty( 'accessToken' ) ) {
            mapboxgl.accessToken = mapboxData.accessToken;

            $( self.selector ).each( function() {
                var $map = $( this ),
                key  = $map.attr( 'data-map' );

                var mapData = mapboxData;

                var map = new mapboxgl.Map( {
                    container: this,
                    style: mapboxData.style,
                    center: [mapData.marker.lon, mapData.marker.lat],
                    zoom: 16,
                    attributionControl: false,
                    scrollZoom: false,
                    interactive: true
                } );

                map.addControl(new mapboxgl.NavigationControl());

                map.on( 'load', function() {
                    $map.addClass( 'map-loaded' );
                } );

                if ( mapData.hasOwnProperty( 'marker' ) ) {
                    var markerData = mapData.marker,
                    markerEl = document.createElement('div');

                    if ( markerData.lat !== null && markerData.lon !== null ) {
                        markerEl.className = 'map__marker';

                        var markerInner = document.createElement('div');
                        markerInner.className = 'map__marker__inner';

                        markerEl.appendChild( markerInner );

                        var markerObject = new mapboxgl.Marker(markerEl)
                            .setLngLat([ markerData.lon, markerData.lat ])
                        .addTo(map);
                    }
                }
            } )
        }
    }
}

export {
    map
};